import { Router, CanActivate } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from '../../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class IsUserNotLogged implements CanActivate {
  constructor(private router: Router, private authService: AuthService) {}

  public canActivate(): boolean {
    if (this.authService.isLogged) {
      this.router.navigate(['/app']);
      return false;
    }
    return true;
  }
}
